import React from 'react';
import { Card, Header2Text, Grid } from 'ui-toolkit';
import { DocumentInformation } from './DocumentInformation';
import { IStandardDocumentData } from '../../types/order/documents/shared/interfaces';
import { eTitleSearchStatus, prettyVendorStatus } from '../../types/order/title/eTitleSearchStatus';
import { PrimaryHeader3 } from './styledComponents/PrimaryHeader';

export interface IVendorDocuments {
  label: string;
  document?: IStandardDocumentData;
}

interface IStatusProps {
  status: eTitleSearchStatus;
  vendorDocuments: IVendorDocuments[];
}

export const StatusSection: React.FC<IStatusProps> = ({ status, vendorDocuments }) => {
  return (
    <Card>
      <Grid>
        <div>
          <Header2Text>Status</Header2Text>
          <PrimaryHeader3>{prettyVendorStatus[status]}</PrimaryHeader3>
        </div>
        <Grid>
          {vendorDocuments.map((document) => (
            <DocumentInformation
              documentName={document.label}
              uploadDateTime={document.document?.fileUpdatedAt}
              key={document.label}
            />
          ))}
        </Grid>
      </Grid>
    </Card>
  );
};
